import { Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import TerritoryFilterCard from "./TerritoryFilter/TerritoryFilterCard";
import TerritoryTable from "./TerritoryTable/TerritoryTable";
import { useDispatch } from "react-redux";
import { selectUserData, setIsLoading } from "../../../../features/userSlice";
import { MetaEntitiesEndPointLogic } from "../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import { useSelector } from "react-redux";
import Page404 from "../../../Page404/Page403";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import SimpleBackdrop from "../../../BackDrop/BackDrop";

interface territoryProps {
  oauthTokenHeader: any;
}

const tableHeadings = {
  territory_name: "Territory Name",
  language: "Language",
  created: "Created on",
  created_by: "Created By",
  modified: "Last edited",
  modified_by: "Edited By",
};

const Territory = ({ oauthTokenHeader }: territoryProps) => {
  const [Metaterritories, setMetaTerritories] = useState([]);
  const [selectedMetaTerritories, setSelectedMetaTerritories] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const response = useSelector(selectUserData);
  const hasViewTerritoryPermission = CheckPermissions(
    response?.data?.products?.admin,
    "meta_entities",
    "view_territories"
  );

  useEffect(() => {
    const fetchMetaEntitiesTrafficClickIdentifier = async () => {
      setIsLoading(true);
      setLoading(true);
      try {
        await MetaEntitiesEndPointLogic.getMetaTerritory(
          oauthTokenHeader,
          dispatch
        );
      } catch (error) {
        console.error("Error fetching Meta Entities:", error);
      } finally {
        setIsLoading(false);
        setLoading(false);
      }
    };
    if (oauthTokenHeader) {
      fetchMetaEntitiesTrafficClickIdentifier();
    }
  }, [oauthTokenHeader, dispatch]);

  if (!hasViewTerritoryPermission) {
    return <Page404 />;
  }

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <Paper
            sx={{
              boxShadow: "none",
              padding: "8px 16px 0px",
              borderEndEndRadius: "0px",
              borderBottomLeftRadius: "0px",
            }}
          >
            <Typography fontSize={24}>Territories List</Typography>
            <TerritoryFilterCard />
          </Paper>
          <Paper
            sx={{
              boxShadow: "none",
              borderTopLeftRadius: "0px",
              borderTopRightRadius: "0px",
            }}
          >
            <TerritoryTable
              loading={loading}
              tableHeadings={tableHeadings}
              Metaterritories={Metaterritories}
              setMetaTerritories={setMetaTerritories}
              oauthTokenHeader={oauthTokenHeader}
              selectedMetaTerritories={selectedMetaTerritories}
              setSelectedMetaTerritories={setSelectedMetaTerritories}
              selectedLanguage={selectedLanguage}
              setSelectedLanguage={setSelectedLanguage}
            />
          </Paper>
        </>
      )}
    </>
  );
};

export default Territory;
